module.exports = "/_next/static/images/window_close-ae1766797fc4cbdc800f81d554928b87.svg";